import { render, staticRenderFns } from "./global-logo-display.vue?vue&type=template&id=27039ab2&scoped=true"
import script from "./global-logo-display.vue?vue&type=script&lang=js"
export * from "./global-logo-display.vue?vue&type=script&lang=js"
import style0 from "./global-logo-display.vue?vue&type=style&index=0&id=27039ab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27039ab2",
  null
  
)

export default component.exports